import { activeCheckbox, inactiveCheckbox } from "helper/icons";

export const CheckBox = (props) => {
  const { label, onChange, isChecked } = props || {};

  return (
    <div className="flex flex-row" onClick={onChange}>
      <img
        className="mr-3"
        src={isChecked ? activeCheckbox : inactiveCheckbox}
        alt=""
      />
      <span className="text-base text-gray-700 font-medium">{label}</span>
    </div>
  );
};
